import React from 'react';
import { CHECKIN_MEMO_MAX } from '../../constants/checkinReasons';
import '../../styles/checkinPopup.css';

/**
 * ひと言（任意）on a できなかった entry — the same field in every place that records 行動記録
 * on the forms (home popup, 記録を編集 sheet). Never required. The AI相談 chat takes the ひと言 from
 * its own input bar instead (owner 2026-10-26), so it does not use this field.
 */
export default function CheckinMemoField({ id, value, onChange }) {
  return (
    <div className="cp-memo-wrap">
      <label className="cp-why-l" htmlFor={id}>ひと言（任意）</label>
      <div className="cp-memo-row">
        <input
          id={id}
          type="text"
          className="cp-memo"
          maxLength={CHECKIN_MEMO_MAX}
          placeholder="例：おすすめする前にお客様が急いで帰られた"
          value={value || ''}
          onChange={(e) => onChange(e.target.value)}
        />
      </div>
    </div>
  );
}
